import { render, staticRenderFns } from "./ViewProfileCompanyPopup.vue?vue&type=template&id=f837aeae&scoped=true"
import script from "./ViewProfileCompanyPopup.vue?vue&type=script&lang=js"
export * from "./ViewProfileCompanyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f837aeae",
  null
  
)

export default component.exports